<template>
	<div class="pp-account-seting-box clearfix mt-50 mb-50"
		v-if="0">
    <!-- 2021/03 以降、利用申請はなくなったため、非表示化。必要になったら復活あり -->
		<div class="logo float-left">
			<img src="../assets/images/pp_logo.png">
		</div>
		<div class="text float-right">
			<p class="red-text">
				オンライン服薬指導を行うには、 <br/>
				ポケットファーマシーサイト側で、<br/>
				ご利用される薬局毎に利用申請が必要です。
			</p>
			<a :href="link" target="_blank" class="button info medium mt-10">
				ポケットファーマシーのサイトを開く
			</a>
		</div>
	</div>
</template>

<script>
	export default {
		data () {
			return {
				link: 'https://pm20.pocketpharmacy.jp/note/account/cooperateSetting'
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/PPAccountSetting.vue